import { Text } from '@/components/ui/text';
import { Input, InputField } from '@/components/ui/input';
import { Box } from '@/components/ui/box';
import React from 'react';
import { IconM } from '../media/IconsV2';

export default function FloatingLabelInput({ testID, ...props }) {
    // TODO: tailwind styling hack h-[80px] h-[100px] h-[200px] h-[300px] w-[70px]
    // testID sits on the outer (View-based) box, not on InputField: nativewind's
    // className-interop on native TextInput swallows testID before it reaches the
    // native view, so Maestro/XCTest never sees it there (verified live on-device).
    return (
        <Box className={props.box}>
            <Input testID={testID} size={props.size || 'lg'} isDisabled={props.isDisabled} className={`p-2 ${props.w ? props.w : ''} ${props.h ? props.h : ''}`}>
                <InputField textAlignVertical="top" selectionColor={'#D2D4D7'} {...props} onPress={null}  className={`${props.icon ? 'pl-12' : 'pl-2'} ${props.fontWeight || 'font-400'}`} />
                {props.icon && <IconM name={props.icon} onPress={props.onPress} className="absolute text-3xl left-2 text-primary-900" />}
                {props.iconR && <IconM name={props.iconR} onPress={props.onPress} className="absolute text-3xl right-2 text-primary-900" />}
            </Input>
            <Text className={`absolute px-2 left-4 -top-2 ${props.isDisabled ? 'text-secondary-400' : 'text-secondary-900'} text-sm leading-4 bg-secondary-50`}>{props.label}</Text>
        </Box>
    );
}
